<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="userRole">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.角色类型') }}<template slot="title">{{ $t('用户.角色类型') }}</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('通用.输入.请选择') + $t('用户.角色')" v-model="form.userRole" allowClear>
          <!--          <a-select-option  :value="10">{{$t('用户角色类型.平台')}}</a-select-option>-->
          <!--          <a-select-option  :value="20">{{$t('用户角色类型.商户')}}</a-select-option>-->
          <a-select-option :value="40">{{ $t('用户.员工') }}</a-select-option>
          <a-select-option :value="50">{{ $t('用户.用户') }}</a-select-option>
          <a-select-option :value="70">{{ $t('用户.营养师') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="mobile">
        <span slot="label">
          <a-tooltip>
            {{ $t('手机号') }}<template slot="title">{{ $t('手机号') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.mobile"
          :maxLength="20"
          :disabled="form.id > 0"
          :placeholder="$t('通用.输入.请输入') + $t('用户.用户名/手机号，用于登录')"
        />
      </a-form-model-item>
      <a-form-model-item prop="password" v-show="!form.id">
        <span slot="label">
          <a-tooltip>
            {{ $t('登录密码') }}<template slot="title">{{ $t('登录密码') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.password" :maxLength="20" :placeholder="$t('通用.输入.请输入') + $t('登录密码')" />
      </a-form-model-item>
      <a-form-model-item prop="email">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.邮箱') }}<template slot="title">{{ $t('用户.邮箱') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.email" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('用户.邮箱')" />
      </a-form-model-item>
      <a-form-model-item prop="avatar">
        <span slot="label">
          <a-tooltip>
            {{ $t('头像') }}<template slot="title">{{ $t('头像') }}</template>
          </a-tooltip>
        </span>
        <OssUploadSingle v-model="form.avatar" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>
      <a-form-model-item prop="nickName">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.昵称') }}<template slot="title">{{ $t('用户.昵称') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.nickName" :maxLength="255" :placeholder="$t('通用.输入.请输入') + $t('用户.昵称')" />
      </a-form-model-item>

      <a-form-model-item prop="sex">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.性别') }}<template slot="title">{{ $t('用户.性别') }}</template>
          </a-tooltip>
        </span>
        <a-select placeholder="请选择性别" v-model="form.sex">
          <a-select-option :value="0">{{ $t('用户.保密') }}</a-select-option>
          <a-select-option :value="1">{{ $t('用户.男') }}</a-select-option>
          <a-select-option :value="2">{{ $t('用户.女') }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('用户.生日')" prop="birthday">
        <a-date-picker style="width: 100%" v-model="form.birthday" valueFormat="YYYY-MM-DD" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="userSign">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.用户个性签名') }}<template slot="title">{{ $t('用户.用户个性签名') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.userSign"
          :maxLength="255"
          :placeholder="$t('通用.输入.请输入') + $t('用户.用户个性签名')"
        />
      </a-form-model-item>
      <a-form-model-item prop="invitationCode">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.邀请码') }}<template slot="title">{{ $t('用户.邀请码') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.invitationCode"
          :maxLength="255"
          disabled
          :placeholder="$t('通用.输入.请输入') + $t('用户.邀请码')"
        />
      </a-form-model-item>
      <!--      <a-form-model-item prop="isNotice" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('用户.是否推送 1-是 0-否')}}<template slot="title">{{$t('用户.是否推送 1-是 0-否')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.isNotice"  :placeholder="$t('通用.输入.请输入')+$t('用户.是否推送 1-是 0-否')" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('用户状态')" prop="status">
        <a-select style="width: 100%" v-model="form.status">
          <a-select-option v-for="(item, index) in this.customDict.UserStatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('用户.解封时间')" prop="unFrozenTime">
        <a-date-picker style="width: 100%" v-model="form.unFrozenTime" valueFormat="YYYY-MM-DD" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>
            {{ $t('用户.备注') }}<template slot="title">{{ $t('用户.备注') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <!--      <a-form-model-item prop="teenagersStatus" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('用户.青少年模式状态 1、开启 0')}}<template slot="title">{{$t('用户.青少年模式状态 1、开启 0')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="teenagersPassword" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('用户.青少年模式密码')}}<template slot="title">{{$t('用户.青少年模式密码')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.teenagersPassword" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('用户.青少年模式密码')" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="directedPush" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('用户.个性化推送,默认开启1 0关闭')}}<template slot="title">{{$t('用户.个性化推送,默认开启1 0关闭')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.directedPush"  :placeholder="$t('通用.输入.请输入')+$t('用户.个性化推送,默认开启1 0关闭')" />-->
      <!--      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUser, addUser, updateUser } from '@/api/biz/user'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import OssUploadSingle from '@/components/OssUploadSingle'
export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    OssUploadSingle,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        nation: null,

        mobile: null,

        email: null,

        password: '123456a',

        avatar: null,

        nickName: null,

        sex: null,

        unFrozenTime: null,
        birthday: null,

        userSign: null,

        invitationCode: null,

        isNotice: null,

        status: 0,

        createTime: null,

        remark: null,

        teenagersStatus: 0,

        teenagersPassword: null,

        directedPush: null,

        userRole: null,

        defaultShopId: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [
          {
            required: true,
            message: this.$t('用户.用户名/手机号，用于登录') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
        email: [
          { required: false, message: this.$t('用户.邮箱，用于登录') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('用户.密码，md5') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        avatar: [
          { required: true, message: this.$t('用户.头像链接') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        nickName: [{ required: true, message: this.$t('用户.昵称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        sex: [
          {
            required: true,
            message: this.$t('用户.性别,0-保密 1-男 2-女') + this.$t('通用.文本.不能为空'),
            trigger: 'change',
          },
        ],
        userSign: [
          { required: false, message: this.$t('用户.用户个性签名') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        isNotice: [
          {
            required: false,
            message: this.$t('用户.是否推送 1-是 0-否') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
        status: [
          {
            required: true,
            message:
              this.$t('用户.用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录') +
              this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        nation: null,
        mobile: null,
        email: null,
        password: '123456a',
        avatar: null,
        nickName: null,
        sex: null,
        unFrozenTime: null,
        birthday: null,
        userSign: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        createTime: null,
        remark: null,
        teenagersStatus: 0,
        teenagersPassword: null,
        directedPush: null,
        userRole: null,
        defaultShopId: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.form.password = null
      this.formType = 2
      const id = row ? row.id : ids
      getUser({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addUser(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
